import clsx from 'clsx';

type Props = {
  id: string;
  isShow: boolean;
  children: React.ReactNode;
  height?: number;
};

export default function Modal({ id, isShow, children, height = undefined }: Props) {
  return (
    <div id={id} aria-hidden="true" className={clsx(isShow ? 'block' : 'hidden')}>
      <div
        tabIndex={-1}
        className="fixed inset-0 z-[100] flex items-center justify-center bg-modal"
      >
        <div
          role="dialog"
          aria-modal="true"
          className={clsx(
            'hidden-scrollbar max-h-screen overflow-auto shadow-[(0px_4px_8px_2px_#0000004D)]',
            height !== undefined ? `h-[${height}px]` : 'max-h-[90vh]'
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
